import { useRef, useState } from 'react';

import type {
  GetRepresentasjonsforholdV1Response,
  SettRepresentasjonsforholdV1Request,
} from '../../types/entities/helsenorge.representasjon.internalapi.entities.entities';

import { get, post } from '@helsenorge/framework-utils/hn-proxy-service';

import { messageAwaken, messageRepresentationChange } from './broker-utils';
/// <reference types="@helsenorge/framework-utils/types/hn"/>
type BeholdPersonType = {
  loading: boolean;
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  valgtRepresentasjonNavn: React.MutableRefObject<string | undefined>;
  hentRepresentasjon: () => Promise<void>;
  handleAwaken: () => void;
  errors: {
    velgRepresentasjonError: boolean;
    hentRepresentasjonError: boolean;
  };
};

export const BeholdPerson = (): BeholdPersonType => {
  const [loading, setLoading] = useState(false);
  const [loadingVelgRepresentasjon, setLoadingVelgRepresentasjon] = useState(false);
  const [velgRepresentasjonError, setVelgRepresentasjonError] = useState<boolean>(false);
  const [hentRepresentasjonError, setHentRepresentasjonError] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const valgtRepresentasjonNavn = useRef<string | undefined>(window.HN?.User?.RepresentertBruker);
  const nyRepresentasjonValgtIAnnenFaneRef = useRef(false);
  const valgtRepresentasjonGuidRef = useRef<string>('');
  const handleAwaken = (): void => {
    if (loadingVelgRepresentasjon) {
      return;
    }
    if (nyRepresentasjonValgtIAnnenFaneRef.current) {
      setBeholdPerson();
    } else {
      messageAwaken();
    }
  };
  const hentRepresentasjon = async (): Promise<void> => {
    try {
      setHentRepresentasjonError(false);
      setLoading(true);
      const data = await get<GetRepresentasjonsforholdV1Response>('representasjon', 'representasjonsforhold/v1');
      const hentetRepresentasjon = data?.representasjonsforhold ?? [];
      if (!valgtRepresentasjonNavn.current) {
        valgtRepresentasjonNavn.current = hentetRepresentasjon.find(r => r.selected)?.fulltNavn;
      }
      for (const element of hentetRepresentasjon) {
        if (element.fulltNavn === valgtRepresentasjonNavn.current) {
          valgtRepresentasjonGuidRef.current = element.profilGuid;
          nyRepresentasjonValgtIAnnenFaneRef.current = !element.selected;
          setShowModal(!element.selected);
          break;
        }
      }
    } catch {
      setHentRepresentasjonError(true);
    } finally {
      setLoading(false);
    }
  };
  const setBeholdPerson = async (): Promise<void> => {
    try {
      setVelgRepresentasjonError(false);
      setLoadingVelgRepresentasjon(true);
      await post<void, SettRepresentasjonsforholdV1Request>('representasjon', 'representasjonsforhold/v1', {
        profilGuid: valgtRepresentasjonGuidRef.current,
      });
      messageRepresentationChange();
      nyRepresentasjonValgtIAnnenFaneRef.current = false;
    } catch {
      setVelgRepresentasjonError(true);
    } finally {
      setLoadingVelgRepresentasjon(false);
    }
  };

  return {
    loading,
    showModal,
    setShowModal,
    valgtRepresentasjonNavn,
    hentRepresentasjon,
    handleAwaken,
    errors: {
      velgRepresentasjonError,
      hentRepresentasjonError,
    },
  };
};
